import React, { Component } from 'react';
import { Menu } from 'antd'
import CustomSearch from './customSearch'
import GraphStatistics from './graphStatistics';
import StatisticsTable from './statisticsTable';

class OperatorPart extends Component {
    state = {
        menuKey: '1'
    }
	handleSelectMenu = (e) => {
		this.setState({
			menuKey: e.key,
		});
	};
    render() {
        return (
            <div style={{ display: "flex", height: "100%" }}>
                <div className="pageLeft" style={{ height: '100%' }}>
                    <Menu
                        mode="inline"
                        className="pageSlderWrap"
                        onClick={this.handleSelectMenu}
                    >
                        <Menu.Item key="1" className={this.state.menuKey === '1' ? 'active' : ''}>
                            <a href='#'>
                                <img src={require("../../assets/image/graphStatistics.png").default} alt="" />
                                <p>统计图形</p>
                            </a>
                        </Menu.Item>
                        <Menu.Item key="2" className={this.state.menuKey === '2' ? 'active' : ''}>
                            <a href='#'>
                                <img src={require("../../assets/image/customSearch.png").default} alt="" />
                                <p>自定义查询</p>
                            </a>
                        </Menu.Item>
                        <Menu.Item key="3" className={this.state.menuKey === '3' ? 'active' : ''}>
                            <a href='#'>
                                <img src={require("../../assets/image/statisticsTable.png").default} alt="" />
                                <p>统计报表</p>
                            </a>
                        </Menu.Item>
                    </Menu>
                </div>
                <>
                    {
                        this.state.menuKey === '1' ? <GraphStatistics /> : null
                    }
                    {
                        this.state.menuKey === '2' ? <CustomSearch /> : null
                    }
                    {
                        this.state.menuKey === '3' ? <StatisticsTable /> : null
                    }
                </>
            </div>
        );
    }
}

export default OperatorPart;